import angular  from 'angular'

import component from './registration-contacts-block.component'

let module = angular.module('registrationContactsBlock', [])

.component('registrationContactsBlock', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/registration/common/registration-contacts-block/index.js